// components/wizard/Keywords.jsx
import React, { useState } from 'react';
import { Loader } from 'lucide-react';

const Keywords = ({ formData, updateFormData, onNext, onBack, saving }) => {
  const [errors, setErrors] = useState({});

  const handleKeywordChange = (index, value) => {
    const newKeywords = [...formData.keywords];
    newKeywords[index] = value;
    updateFormData({ keywords: newKeywords });
  };

  const validate = () => {
    const filledKeywords = formData.keywords.filter(k => k.trim() !== '').length;
    if (filledKeywords < 3) {
      setErrors({ keywords: 'Please provide at least 3 keywords' });
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (saving) return;
    if (validate()) {
      onNext();
    }
  };

  return (
    <div>
      <h3 className="text-xl font-semibold mb-6">Keywords</h3>
      
      <div className="grid grid-cols-2 gap-6">
        {formData.keywords.map((keyword, index) => (
          <div key={index}>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Keyword {index + 1}
            </label>
            <input
              type="text"
              value={keyword}
              onChange={(e) => handleKeywordChange(index, e.target.value)}
              className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-[--asfi-blue] ${
                index < 3 && !keyword && errors.keywords
                  ? 'border-red-500 bg-red-50'
                  : 'border-gray-300'
              }`}
              placeholder={`Enter keyword ${index + 1}`}
            />
          </div>
        ))}
      </div>

      {errors.keywords && (
        <p className="mt-4 text-sm text-red-500">{errors.keywords}</p>
      )}

      <p className="text-sm text-red-500 mt-6">* Indicates Mandatory Fields</p>

      <div className="flex justify-between mt-6">
        <button
          onClick={onBack}
          className="px-8 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
        >
          Back
        </button>
        
        <button
          onClick={handleSubmit}
          disabled={saving}
          className="px-8 py-3 bg-[--asfi-blue] text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
        >
          {saving ? (
            <>
              <Loader className="w-4 h-4 animate-spin inline mr-2" />
              Saving...
            </>
          ) : (
            'Save & Continue'
          )}
        </button>
      </div>
    </div>
  );
};

export default Keywords;
